import { useState, useLayoutEffect } from 'react';
import { useMountStatus } from './useMountStatus';

interface UseSynchronizedArrayParams<T, U> {
    data: T;
    onChange: (newData: T) => void;
    preprocess: (data: T) => U;
    postprocess: (data: U) => T;
}

export function useSynchronizedData<T, U>({
    data,
    onChange,
    preprocess,
    postprocess,
}: UseSynchronizedArrayParams<T, U>): [U, React.Dispatch<React.SetStateAction<U>>] {
    const initialData = preprocess(data);

    const [synchronizedData, setSynchronizedData] = useState(initialData);
    const statusRef = useMountStatus();

    useLayoutEffect(() => {
        if (statusRef.current) {
            onChange(postprocess(synchronizedData));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [synchronizedData]);

    return [synchronizedData, setSynchronizedData];
}
